/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css, cx } from "@panda/css";

import { Box, BoxProps } from "@panda/jsx";

export interface CosmosTableColumnProps extends BoxProps {
	children: React.ReactNode;
}

const tableColumnStyles = css({
	paddingBlock: "eds.dimension.8",
	paddingInline: "eds.dimension.24",
});

/**
 * Expects to be used within TableHeader. If the same gridTemplateColumns is passed to TableHeader and TableRows,
 * each TableColumn will should align with TableCells below it.
 */

export const CosmosTableColumn = ({ children, className, ...props }: CosmosTableColumnProps): React.JSX.Element => {
	return (
		<Box {...props} className={cx("cosmos-table__column", tableColumnStyles, className)}>
			{children}
		</Box>
	);
};

CosmosTableColumn.displayName = "CosmosTable.Column";
